export default () => Component(function ($context) {
	return $context.select('.filter');
}, function ($filter, self) {
	$.extend(self, {
		initEventListeners: function () {
			$filter.on('change', 'input:not(.filter__search-field)', function(e) {
				const $input = $(e.target);
				if (ResponsiveUtil.isDesktopUp() || $input.hasClass('range-slider__input')) {
					$filter.trigger('filter_changed', $(this).closest('.filter__tooltip-anchor'))
					window.setTimeout(self.submitForm);
				} else {
					self.toggleCheckAllBtn();
					self.toggleSubmitBlock();
				}
			})
			$filter.on('click', '.filter__submit-btn', function() {
				self.submitForm();
			});
			$filter.on('click', '.filter__reset-value', function() {
				var $resetBtn = $(this);
				var value = $resetBtn.data('value');

				self.resetValue(value);
				$resetBtn.remove();
			});
			$filter.on('click', '.js-filter-open', function() {
				self.toggleContent(true);
			});
			$filter.on('click', '.js-filter-close', function() {
				self.toggleContent(false);
				self.toggleCheckboxes();
			});
			$filter.on('click', '.filter__check-all-btn', function() {
				self.toggleCheckboxes(!$(this).hasClass('filter__check-all-btn--uncheck'));
			});
			$filter.on('click', '.filter__reset-btn', function(e) {
				e.stopPropagation();
				self.reset();
			});
			$(document).on('products_filtered', (e, html) => {
				self.updateBlocks(html);
				self.toggleSelectedClass();
				self.toggleContent(false);
			});
			$(document).on('click', '.js-filters-toggler', function(){
				self.toggleContent(false);
				self.toggleCheckboxes();
			});
		},
		getCode: function() {
			return $filter.data('code');
		},
		isCheckboxType: function () {
			return $filter.is('.filter_type_checkbox');
		},
		isColorType: function () {
			return $filter.is('.filter_type_color-checkbox');
		},
		isBooleanType: function () {
			return $filter.is('.filter_type_boolean');
		},
		isRangeType: function () {
			return $filter.is('.filter_type_range') || $filter.is('.c-filter_type_price');
		},
		getValues: function () {
			return $filter.find('.filter__item');
		},
		toggleSelectedClass: function() {
			self.getValues().each(function() {
				const $value = $(this);
				const $checkbox = $value.find('.checkbox__input');

				$value.toggleClass('filter__item_selected', $checkbox.is(':checked'));
			})
		},
		getSelectedValues: function () {
			return self.getValues().filter('.filter__item_selected');
		},
		getNotSelectedValues: function() {
			return self.getValues().not('.filter__item_selected');
		},
		isSelected: function () {
			var isSelected = false;

			if (self.isRangeType()) {
				$filter.find('.range-slider__input').each(function() {
					var input = $(this);

					if (input.val() !== '' && isSelected === false) {
						isSelected = true;
					}
				});
			}

			return isSelected;
		},
		reset: function () {
			$filter.find('.filter__reset-input').each(function () {
				var $input = $(this);

				if ($input.val() !== '') {
					$input.val('').trigger('change');
				}
			});
			$filter.find('.checkbox__input').each(function () {
				var $checkbox = $(this);

				if ($checkbox.prop('checked')) {
					$checkbox.prop('checked', false).trigger('change');
				}
			});
			self.submitForm();
		},
		toggleCheckboxes: function (checkAll = undefined) {

			self.getValues().each(function() {
				const $value = $(this);
				const $checkbox = $value.find('.checkbox__input');

				if (($value.hasClass('filter__item_selected') || checkAll === true) && checkAll !== false) {
					$checkbox.prop('checked', true)
				} else {
					$checkbox.prop('checked', false)
				}
			})

			self.toggleCheckAllBtn();
			self.toggleSubmitBlock();
		},
		checkIsAllCheckboxesChecked: function() {
			let isAllChecked = true;

			self.getValues().each(function() {
				const $value = $(this);
				const $checkbox = $value.find('.checkbox__input');

				if (!$checkbox.is(':checked')) {
					isAllChecked = false;
					return;
				}
			});

			return isAllChecked;
		},
		toggleCheckAllBtn: function() {
			const $btn = $filter.find('.filter__check-all-btn');

			if ($btn.length > 0) {
				const isAllCheckboxesChecked = self.checkIsAllCheckboxesChecked();
				const btnText = isAllCheckboxesChecked ? $btn.data('uncheck') : $btn.data('check');

				$btn.toggleClass('filter__check-all-btn--uncheck', isAllCheckboxesChecked).html(btnText);
			}
		},
		checkForChangedValues: function() {
			let hasChanged = false;
			self.getValues().each(function() {
				const $value = $(this);
				const $checkbox = $value.find('.checkbox__input');

				if ($value.hasClass('filter__item_selected') && !$checkbox.is(':checked') ||
					!$value.hasClass('filter__item_selected') && $checkbox.is(':checked')) {
					hasChanged = true;
					return;
				}
			})

			return hasChanged;
		},
		resetValue: function(value) {
			const $inputs = $filter.find(`[value="${value}"]`);

			$inputs.each(function(){
				$(this).prop('checked', false).trigger('change');
				self.submitForm();
			});
		},
		getForm: function() {
			return $filter.closest('.filters__form');
		},
		submitForm: function() {
			self.getForm().submit();
		},
		getContentBlock: function () {
			return $filter.find('.filter__content');
		},
		toggleContent: function(toOpen) {
			const $content = self.getContentBlock();
			self.getForm().find('.filter__content').removeClass('filter__content_show');

			if ($content.length > 0) {
				$content.toggleClass('filter__content_show', toOpen);
			}

			self.toggleCheckAllBtn();
			self.toggleSubmitBlock();
		},
		updateBlocks: function(html) {
			const $activeValuesBlock = self.getActiveValuesBlock();
			const $resetBlock = self.getResetBlock();
			const hasActiveValuesBlock = $activeValuesBlock.length > 0;
			const hasRestBlock = $resetBlock.length > 0;

			if (hasActiveValuesBlock || hasRestBlock) {
				const code = self.getCode();

				if (code !== undefined) {
					const $tmp = $('<div></div>').html(html);
					const $newFilterBlock = $tmp.find('.filter[data-code="' + code + '"]');

					if (hasActiveValuesBlock) {
						self.setActiveValuesBlocks($newFilterBlock, $activeValuesBlock)
					}

					if (hasRestBlock) {
						self.setResetBlock($resetBlock)
					}
				}
			}
		},
		getActiveValuesBlock: function() {
			return $filter.find('.filter__active-list');
		},
		getResetBlock: function() {
			return $filter.find('.filter__reset-block');
		},
		setActiveValuesBlocks: function($newFilterBlock, $activeValuesBlock) {
			const $newActiveValuesBlock = $newFilterBlock.find('.filter__active-list');
			$activeValuesBlock.html($newActiveValuesBlock.html());
		},
		setResetBlock: function($resetBlock) {
			let hasActiveValues = false;
			let $resetBlockHtml = '';

			const inputs = $filter.find('input');
			inputs.each(function(){
				const input = $(this);
				if (input.attr('type') === 'checkbox') {
					hasActiveValues = input.prop('checked') === true;
				} else {
					hasActiveValues = input.val() !== '';
				}

				if (hasActiveValues) {
					return false;
				}
			});

			if (hasActiveValues) {
				$resetBlockHtml = $('<div class="filter__reset-btn">Сбросить</div>');
			}

			$resetBlock.html($resetBlockHtml);
		},
		getSubmitBlock: function() {
			return $filter.find('.filter__submit-block');
		},
		toggleSubmitBlock: function() {
			const $submitblock = self.getSubmitBlock();

			if ($submitblock.length > 0) {
				$submitblock.toggleClass('filter__submit-block--show', self.checkForChangedValues());
			}
		}
	})

	self.initEventListeners();
	self.toggleCheckAllBtn();
})
